import { injectable, inject } from 'inversify';
//import { InteractionEvent } from '@/app/statistics/events/interaction-events';
//import { QuestionEvent } from '@/app/question/events/question-events';
import { NavigationEvent } from '@/app/statistics/events/navigation-events';
import { SectionStatusEvent } from '@/app/statistics/events/section-status-events';
import { Scorm2004Client, ErrorHandlingScorm2004ClientSymbol, ErrorHandlingScorm2004Client } from '../client';
import { HandledEvents } from './handled-events';
import { StoreCommandExecutor } from '../../../common';
import { Command, Query } from '../../../common'
import { SectionStateProjection, SessionTimeProjection } from '@/app/section-state/tracking/projection';
//import { InteractionStateProjection } from '@/app/interaction/tracking/projection';
//import { QuestionStateProjection } from '@/app/question/tracking/projection';
import { BookmarkStateProjection } from '@/app/bookmark/tracking/projection';
import { ScormErrorNotificationServiceSymbol, ScormErrorNotificationService } from '../client/scorm-notification-service';

export const InitializedPhaseFactorySymbol = Symbol.for('Factory<InitializedPhase>');
export type InitializedPhaseFactory = (client: Scorm2004Client) => InitializedPhase;

@injectable()
export class InitializedPhase {

  @inject(BookmarkStateProjection)
  private bookmarkState: BookmarkStateProjection;
  @inject(SessionTimeProjection)
  private sessionTimeState: SessionTimeProjection;
  @inject(SectionStateProjection)
  private sectionState: SectionStateProjection;
  // @inject(InteractionStateProjection)
  // private interactionState: InteractionStateProjection;
  // @inject(QuestionStateProjection)
  // private questionState: QuestionStateProjection;
  @inject(StoreCommandExecutor)
  private readonly commandQueue: StoreCommandExecutor;
  @inject(ErrorHandlingScorm2004ClientSymbol)
  private readonly errorHandlingClient: ErrorHandlingScorm2004Client;
  @inject(ScormErrorNotificationServiceSymbol)
  private readonly errorNotificationService: ScormErrorNotificationService

  constructor(
  ) {}

  public enter() {
    this.commandQueue.start();
    this.errorHandlingClient.start();
    this.errorNotificationService.start();
  }

  public async exit() {
    await this.commandQueue.finish();
    this.errorNotificationService.stop();
    await this.errorHandlingClient.finish()
  }

  public execute(command: Command) {
    this.commandQueue.queue(command)
  }

  public async query<T extends string, TPayload, TResult>(query: Query<T, TPayload, TResult>): Promise<TResult> {
    const result = await this.commandQueue.query(query)
    return result
  }

  public async handleEvent(event: HandledEvents): Promise<void> {
    let handled = await this.sectionState.handle(event as (NavigationEvent | SectionStatusEvent));
    handled = await this.bookmarkState.handle(event as NavigationEvent) || handled;
    handled = this.sessionTimeState.handle(event as NavigationEvent) || handled;
//    handled = await this.interactionState.handle(event as InteractionEvent) || handled;
//    handled = await this.questionState.handle(event as QuestionEvent) || handled;
  }
}
